export const DottedCircleIcon = () => {
  return (
    <svg
      className="sn-icon no-fill stroke-neutral-color block"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        strokeDasharray="2 2"
      />
    </svg>
  )
}
